import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from "@angular/common/http";
// import { MDBBootstrapModule } from 'angular-bootstrap-md';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {MatProgressBarModule } from '@angular/material/progress-bar';
import {MatCardModule } from '@angular/material/card';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { DatePipe } from '@angular/common'

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';


import { PreloadFactory } from "./Shared/FactoryService/preload-service.factory";
import { ConfigLoaderService } from '../app/Shared/Services/Config/config-loader.service';


import { ModalComponent } from './Shared/Components/modal/modal.component';
import { OfflineComponent } from './components/offline/offline.component';


import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { ContactModalComponent } from './Shared/Components/contact-modal/contact-modal.component';
import { AboutUSComponent } from './components/about-us/about-us.component';
import { OfferingComponent } from './components/offering/offering.component';
import { DeploymentApproachComponent } from './components/deployment-approach/deployment-approach.component';
import { SpooldownloadModalComponent } from './Shared/Components/spooldownload-modal/spooldownload-modal.component';
import {AdminComponent} from './components/admin/admin.component';
import {NotificationComponent} from './components/admin/notification/notification.component';
import {DocketUploadComponent} from './components/docket-upload/docket-upload.component';
import{ProjectPermissionComponent} from './components/project-permission/project-permission.component'

import {MsalApplicationModule} from './msal-application.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import {ExternalLinkDirective} from './external-link-directive';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { MsalRedirectComponent } from '@azure/msal-angular';
import { DocketFormComponent } from './components/docket-form/docket-form.component';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';






@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        AccessDeniedComponent,
        ModalComponent,
        OfflineComponent,
        ContactModalComponent,
        SpooldownloadModalComponent,
        AboutUSComponent,
        OfferingComponent,
        DeploymentApproachComponent,
        PageNotFoundComponent,
        AdminComponent,
        NotificationComponent,
        DocketUploadComponent,
        ProjectPermissionComponent,
        DocketFormComponent,
        DisclaimerComponent
    ],
    bootstrap: [AppComponent,MsalRedirectComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], 
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatToolbarModule,
        MatIconModule,
        MatSelectModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        MsalApplicationModule.forRoot("./assets/config/config.json"),
        NgbModule], 
        providers: [
            
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        MatDatepickerModule,
        MatNativeDateModule,
        DatePipe,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
